import {
  DocumentOrganizationKeys,
  FilterDocument,
} from 'shared/types/filter-document';
import { SmartList } from 'shared/types/smart-list';

import { getDefaultFilterDocument } from './get-default-filter-document';

export const getFilterDocument = (smartList?: SmartList): FilterDocument => {
  const base = getDefaultFilterDocument(smartList);

  return {
    ...base,
    ...(smartList?.filterDocument ?? {}),
    [DocumentOrganizationKeys.Filters]: {
      ...base.filters,
      ...(smartList?.filterDocument?.filters ?? {}),
    },
  };
};
